import { render } from "./WCEbtRefundsModal.vue?vue&type=template&id=56d8683a&ts=true"
import script from "./WCEbtRefundsModal.vue?vue&type=script&lang=ts"
export * from "./WCEbtRefundsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__